import InfoIcon from "./IconsSvg/InfoIcon";
import { GuidStatus } from "styles/jss/FormPages.styles";

export default function GuidInfo({ text }) {
  return (
    <GuidStatus>
      <i>
        <InfoIcon />
      </i>
      <p>
        {!!text
          ? text
          : ` در سوالات میزان اهمیت، گزینه ۱ کمترین اهمیت و گزینه ۳ بیشترین اهمیت را
        نشان می دهد.`}
      </p>
    </GuidStatus>
  );
}
